const $ = require('jquery');

// Make it easier to use jQuery from the console
window.$ = $;

require('./components/form.js');
require('./components/scroll-on-click.js');
require('./components/shadowbox.js');
require('./components/header.js');
require('./components/hero.js');
require('./components/hope-heroes.js');
require('./components/page-title.js');
require('./components/jumpmenu.js');
require('./components/sticky-nav.js');
require('./components/search-modal.js');

// animations
require('./components/page-animations.js');
